import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';

import Button from '../../../components/ui/Button';

const MapFilters = ({ onFilterChange, activeFilters }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [localFilters, setLocalFilters] = useState(activeFilters);

  const zoneOptions = [
    { value: 'all', label: 'Tutte le zone' },
    { value: 'centro-storico', label: 'Centro Storico' },
    { value: 'corso-cairoli', label: 'Corso Cairoli' },
    { value: 'corso-cavour', label: 'Corso Cavour' },
    { value: 'collevario', label: 'Collevario' },
    { value: 'sforzacosta', label: 'Sforzacosta' },
    { value: 'piediripa', label: 'Piediripa' },
    { value: 'villa-potenza', label: 'Villa Potenza' },
    { value: 'fuori-le-mura', label: 'Fuori le Mura' }
  ];

  const categoryOptions = [
    { value: 'all', label: 'Tutte le categorie' },
    { value: 'ristoranti', label: 'Ristoranti' },
    { value: 'moda', label: 'Moda & Abbigliamento' },
    { value: 'bar-caffe', label: 'Bar & Caffè' },
    { value: 'cultura', label: 'Cultura & Tempo Libero' },
    { value: 'salute', label: 'Salute & Benessere' },
    { value: 'servizi', label: 'Servizi' },
    { value: 'alimentari', label: 'Alimentari' }
  ];

  const radiusOptions = [
    { value: '1', label: '1 km' },
    { value: '2', label: '2 km' },
    { value: '5', label: '5 km' },
    { value: '10', label: '10 km' },
    { value: 'all', label: 'Tutta la città' }
  ];

  const handleFilterUpdate = (key, value) => {
    const updated = { ...localFilters, [key]: value };
    setLocalFilters(updated);
    onFilterChange(updated);
  };

  const handleReset = () => {
    const resetFilters = {
      zone: 'all',
      category: 'all',
      radius: '5',
      hasPromotion: false,
      hasCashback: false,
      openNow: false
    };
    setLocalFilters(resetFilters);
    onFilterChange(resetFilters);
  };

  const activeFilterCount = Object.values(localFilters)?.filter(v => 
    v !== 'all' && v !== false && v !== '5'
  )?.length;

  return (
    <div className="bg-card rounded-lg shadow-warm p-4 mb-4">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <Icon name="Filter" size={20} color="var(--color-primary)" />
          <h3 className="font-heading text-lg font-semibold text-foreground">
            Filtri Mappa
          </h3>
          {activeFilterCount > 0 && (
            <span className="bg-primary text-primary-foreground px-2 py-0.5 rounded-full font-caption text-xs font-semibold">
              {activeFilterCount}
            </span>
          )}
        </div>
        <div className="flex items-center gap-2">
          {activeFilterCount > 0 && (
            <Button
              variant="ghost"
              size="sm"
              iconName="X"
              iconPosition="left"
              onClick={handleReset}
            >
              Resetta
            </Button>
          )}
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="lg:hidden w-8 h-8 rounded-lg bg-muted flex items-center justify-center transition-smooth hover:bg-primary/10 focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3"
            aria-label={isExpanded ? 'Chiudi filtri' : 'Espandi filtri'}
          >
            <Icon name={isExpanded ? "ChevronUp" : "ChevronDown"} size={20} />
          </button>
        </div>
      </div>
      <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 ${isExpanded ? 'block' : 'hidden lg:grid'}`}>
        <Select
          label="Zona"
          options={zoneOptions}
          value={localFilters?.zone}
          onChange={(value) => handleFilterUpdate('zone', value)}
        />

        <Select
          label="Categoria"
          options={categoryOptions}
          value={localFilters?.category}
          onChange={(value) => handleFilterUpdate('category', value)}
        />

        <Select
          label="Raggio"
          options={radiusOptions}
          value={localFilters?.radius}
          onChange={(value) => handleFilterUpdate('radius', value)}
        />

        <div className="space-y-3">
          <label className="block font-caption text-sm font-medium text-foreground mb-2">
            Opzioni
          </label>
          <div className="space-y-2">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={localFilters?.hasPromotion}
                onChange={(e) => handleFilterUpdate('hasPromotion', e?.target?.checked)}
                className="w-4 h-4 rounded border-input text-primary focus:ring-3 focus:ring-ring focus:ring-offset-3"
              />
              <span className="font-body text-sm text-foreground">Con promozioni</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={localFilters?.hasCashback}
                onChange={(e) => handleFilterUpdate('hasCashback', e?.target?.checked)}
                className="w-4 h-4 rounded border-input text-primary focus:ring-3 focus:ring-ring focus:ring-offset-3"
              />
              <span className="font-body text-sm text-foreground">Con cashback</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={localFilters?.openNow}
                onChange={(e) => handleFilterUpdate('openNow', e?.target?.checked)}
                className="w-4 h-4 rounded border-input text-primary focus:ring-3 focus:ring-ring focus:ring-offset-3"
              />
              <span className="font-body text-sm text-foreground">Aperto ora</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapFilters;